import React from "react";
import { useParams } from "react-router-dom";
import FooterOne from "../common/footer/FooterOne";
import HeaderOne from "../common/header/HeaderOne";
import BcrumbBannerOne from "../elements/breadcrumb/BcrumbBannerOne";
import CtaLayoutOne from "../component/cta/CtaLayoutOne";
import SectionTitle from "../elements/section-title/SectionTitle";
import ProjectPropOne from "../component/project/itemProp/ProjectPropOne";
import { slugify } from "../utils";
import ServiceData from "../data/service/ServiceMain.json";
import ProjectData from "../data/project/ProjectData.json";
import AboutTwo from "../component/about/AboutTwo";
import ColorSwitcher from "../elements/switcher/ColorSwitcher";
import SEO from "../common/SEO";
import Tilty from "react-tilty";
import CounterUpTwo from "../component/counterup/CounterUpTwo";
import AboutThree from "../component/about/AboutThree";
import ClientOne from "../component/client/ClientOne";
import BcrumbBannerTwo from "../elements/breadcrumb/BcrumbBannerTwo";
import CertificateGridCard from "../component/certificate/CertificateGridCard";
import BreadCrumbOne from "../elements/breadcrumb/BreadCrumbOne";
import ClientSlider from "../component/client/ClientSlider";
import ProjectOne from "../component/project/ProjectOne";
import BcrumbBannerSmartTech from "../elements/breadcrumb/BcrumbBannerSmartTech";

const allServiceData = ServiceData;
const getProjectData = ProjectData;

const SmartTech = () => {
  // const params = useParams();
  // const serviceSlug = params.slug;

  // const getServiceData = allServiceData.filter(data => slugify(data.title) === serviceSlug);
  const detailsService = ServiceData[0];

  return (
    <>
      <SEO title="Service Details" />
      {/* <ColorSwitcher /> */}
      <main className="main-wrapper">
        <HeaderOne />
        <BcrumbBannerSmartTech
          title="Embracing Technology for Advanced Facilities Management in the UAE"
          paragraph="In today’s fast-paced world, technology is revolutionizing the way facilities are managed, and the UAE is at the forefront of adopting these innovations. The integration of smart technologies in facilities management not only enhances operational efficiency but also promotes sustainability, reduces costs, and improves the overall user experience. At UCWF, we are committed to leveraging cutting-edge technology to deliver superior facilities management services that meet the evolving demands of businesses and industries in the UAE."
          styleClass=""
          page="Smart-Tech"
          titleCategory="Smart Tech"
          // mainThumb="/images/smartTech/ucwf-mobile.png"
          mainThumb={[
            { mainThumb: "/images/smartTechucwf/ucwf-mobile-1.webp" },
            { mainThumb: "/images/smartTechucwf/ucwf-mobile-2.webp" },
            { mainThumb: "/images/smartTechucwf/ucwf-mobile-3.webp" },
          ]}
          color="" // Pass the color prop here
          
        />
        {/* <BreadCrumbOne
          subtitle=" "
          title=" "
          page="smart-tech"
        /> */}

        {/* <CertificateGridCard/> */}
        <ProjectOne
          title=""
          subtitle=""
          isHomePage={false}
          isSmartTech={true}
        />

        <CounterUpTwo />
        <AboutThree />
        <div className="container " style={{ paddingTop: "100px" }}>
          <SectionTitle
            subtitle="Our Clients"
            title="Our valued partners"
            textAlignment="heading-left mb--40"
            textColor=""
          />
        </div>
        {/* // In your page/component: */}
        <ClientSlider
          itemShow={4}
          colSize="col-md-3"
          columnGap="row-35"
          parentClass="your-custom-class"
        />

        {/* <CtaLayoutOne /> */}
        <FooterOne parentClass="" />
      </main>
    </>
  );
};

export default SmartTech;
